// import cookie from 'js-cookie'
import axios from 'axios'
import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { parent, weixin, unionaccount } = gateway

export function unbindOpenId (params) {
  return request({
    url: `${parent}/api/wx/unbind`,
    method: 'GET',
    params
  })
}
// 获取微信公众号jssdk鉴权信息
export function getWxConfig (params) {
  return request({
    url: `${weixin}/wx/multi/open/js/getConfig`,
    // url: 'http://stage-weixin.vipkid-qa.com.cn/wx/multi/open/js/getConfig',
    method: 'GET',
    params
  })
}

// 手机验证码登录 获取验证码
export function sendSmsCode (params, headers) {
  return axios.request({
    // url: 'http://test-api.vipkid-qa.com.cn/pub/union-account/account/mutilbusiness/loginBySmsCode',
    url: `${unionaccount}/account/verifycode/ai/send/sms`,
    method: 'POST',
    params,
    headers
  })
}
// 手机验证码登录 登录接口
export function loginByCode (params) {
  return axios.request({
    url: `${unionaccount}/account/mutilbusiness/loginBySmsCode`,
    // url: 'http://test-api.vipkid-qa.com.cn/pub/union-account/account/mutilbusiness/loginBySmsCode',
    method: 'POST',
    data: params,
    transformRequest: [function (data) {
      // 将数据转换为表单数据
      console.log(data)
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret.replace(/&$/, '')
    }]
    // headers: {
    //   'content-type': 'application/x-www-form-urlencoded'
    // }
  })
}
// 其他业务线引流1v1 token登录
export function drainageSignUp (params) {
  return request({
    url: `${unionaccount}/account/multibusiness/token/drainageSignUp`,
    // url: 'http://test-api.vipkid-qa.com.cn/pub/union-account/account/mutilbusiness/loginBySmsCode',
    method: 'POST',
    data: params,
    transformRequest: [function (data) {
      // 将数据转换为表单数据
      console.log(data)
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret.replace(/&$/, '')
    }]
    // headers: {
    //   'Authorization': cookie.get('Authorization')
    // }
  })
}
